import * as PageQueries from '../../queries/page';
import { makeApolloClient, logError } from '../util';

export const SET_EVENT_PAGES = 'SET_EVENT_PAGES';
export const SET_PAGE = 'SET_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';

export const updatePage = page => ({
	type: SET_PAGE,
	page,
});

export const deletePage = ({ id }) => ({
	type: DELETE_PAGE,
	pageID: id,
});

export const createPage = page => ({
	type: SET_PAGE,
	page,
});

const fetchEventPages = (pages, from) => ({
	type: SET_EVENT_PAGES,
	from,
	pages,
});

export const thunkFetchEventPages = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventPages } = await client.request(PageQueries.EVENT_PAGES, {
			event_id: eventID,
		});
		dispatch(fetchEventPages(eventPages, from));
		return eventPages;
	} catch (error) {
		logError(error, 'pages.actions.thunkFetchEventPages');
	}
};

const fetchPage = (page, from) => ({
	type: SET_PAGE,
	from,
	page,
});

export const thunkFetchPage = (pageID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { page } = await client.request(PageQueries.PAGE, {
			id: pageID,
		});
		dispatch(fetchPage(page, from));
	} catch (error) {
		logError(error, 'pages.actions.thunkFetchPage');
	}
};
